import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { Flex, Icon, Expandable, Block } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import GoalMatrixRowForm from './GoalMatrixRowForm';
import { capitalize } from 'helpers/content';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';
import { ColorLabel, ColorLabelContainer } from 'UI';
import './_OnlyFeedbackForm.scss';

var OnlyFeedbackForm = function OnlyFeedbackForm(props) {
  var _props$part$value$row, _props$part, _props$part$value;

  var translate = useTranslate();

  var _useState = useState((_props$part$value$row = (_props$part = props.part) === null || _props$part === void 0 ? void 0 : (_props$part$value = _props$part.value) === null || _props$part$value === void 0 ? void 0 : _props$part$value.rows) !== null && _props$part$value$row !== void 0 ? _props$part$value$row : []),
      _useState2 = _slicedToArray(_useState, 2),
      rows = _useState2[0],
      setRows = _useState2[1];

  useEffect(function () {}, []);

  var removeMatrix = function removeMatrix() {
    if (props.onRemove != null) {
      props.onRemove();
    }
  };
  /**
   * @param {string} target
   * @param {string} referenceType
   * @description Toggles target permission on part data
   */


  var togglePermission = function togglePermission(target, referenceType) {
    var _props$part$permissio;

    var permissions = props.part.permissions;
    var indexOf = (_props$part$permissio = props.part.permissions) === null || _props$part$permissio === void 0 ? void 0 : _props$part$permissio.findIndex(function (element) {
      return element.target == target && element.referenceType == referenceType;
    });

    if (indexOf > -1) {
      permissions.splice(indexOf, 1);
    } else {
      permissions.push({
        target: target,
        referenceType: referenceType,
        level: 'READ'
      });
    }

    props.onChange(_objectSpread(_objectSpread({}, props.part), {}, {
      permissions: permissions
    }));
  };

  var renderAssessmentFeedbackPermission = function renderAssessmentFeedbackPermission() {
    var _props$part$permissio2;

    var active = ((_props$part$permissio2 = props.part.permissions) === null || _props$part$permissio2 === void 0 ? void 0 : _props$part$permissio2.find(function (element) {
      return element.target == 'GUARDIAN' && element.referenceType == 'ASSESSMENTFEEDBACK';
    })) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission active",
      onClick: function onClick(event) {
        event.stopPropagation();
        togglePermission('GUARDIAN', 'ASSESSMENTFEEDBACK');
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize('Show feedback for guardians'))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "only-feedback-container-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Alert",
    bw: true
  }), " ", translate('You can always provide feedback. If you add learning goals or a curriculum, then the feedback will be tied to these.')), /*#__PURE__*/React.createElement("div", {
    className: "trigger-container"
  }, renderAssessmentFeedbackPermission()));
};

OnlyFeedbackForm.defaultProps = {
  assessments: [],
  disabled: false
};
export default OnlyFeedbackForm;